import { PageHeader, Stack, TabNav, type TabNavItem } from '@ui';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation } from 'react-router';
import { PageActionsProvider, PageActionsSlot } from '../../app/PageActions';
import { RouterLink } from '../../app/RouterLink';

/** Frame of the statistics and reports: title, the tab's actions and tabs (specs/10). */
export function ReportsLayout() {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const tabs: TabNavItem[] = (
    [
      { key: 'yield', label: t('reports.tabs.yield'), href: '/auswertungen' },
      { key: 'sales', label: t('reports.tabs.sales'), href: '/auswertungen/verkauf' },
      { key: 'exports', label: t('reports.tabs.exports'), href: '/auswertungen/berichte' },
    ] satisfies TabNavItem[]
  ).map((tab) => ({
    ...tab,
    active:
      tab.href === '/auswertungen' ? pathname === '/auswertungen' : pathname.startsWith(tab.href),
  }));
  return (
    <PageActionsProvider>
      <Stack gap={4}>
        <PageHeader title={t('reports.title')} actions={<PageActionsSlot />} />
        <TabNav label={t('reports.tabs.label')} items={tabs} linkComponent={RouterLink} />
        <Outlet />
      </Stack>
    </PageActionsProvider>
  );
}
